"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.treatmentService = exports.TreatmentService = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/json/stringify"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/promise"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/values"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/from"));

var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/set"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _uuid = require("uuid");

var _fetch2 = require("../fetch");

var clientIdKey = 'ms-client-id';
var flightsKey = 'ms-flight-override';
/**
 * Represents a services to do A/B UI testing via a set of flights that an user can be assigned to
 */

var TreatmentService = /*#__PURE__*/function () {
  function TreatmentService(storage) {
    var fetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (input, init) {
      return (0, _fetch2.fetch)(input, init);
    };
    (0, _classCallCheck2.default)(this, TreatmentService);
    this.clientId = void 0;
    this._endpoint = void 0;
    this._flights = void 0;
    this._flightIds = void 0;
    this._storage = void 0;
    this._pendingFlightRequest = void 0;
    this._fetch = void 0;

    // window.localStorage can be undefined on test environments
    if (storage === undefined) {
      try {
        // Even accessing localStorage can throw
        storage = window.localStorage;
      } catch (err) {
        console.error(err);
      }
    }

    this._storage = storage;
    this._fetch = fetch;
    var clientId;

    try {
      if (storage !== undefined) {
        clientId = storage.getItem(clientIdKey);
        var flights = storage.getItem(flightsKey);

        if (flights !== null) {
          var _context;

          this._flights = (0, _reduce.default)(_context = JSON.parse(flights)).call(_context, function (set, key) {
            return set.add(key);
          }, new _set.default());
        }
      }
    } catch (err) {
      console.error(err);
    }

    if (!clientId) {
      clientId = (0, _uuid.v4)().replace(/-/g, '');

      try {
        if (storage !== undefined) {
          storage.setItem(clientIdKey, clientId);
        }
      } catch (err) {
        console.error(err);
      }
    }

    this.clientId = clientId;
  }

  (0, _createClass2.default)(TreatmentService, [{
    key: "setEndpoint",
    value: function setEndpoint(url) {
      this._endpoint = url;
    }
  }, {
    key: "getCachedFlags",
    value: function getCachedFlags() {
      return this._flights;
    }
    /**
     * Gets a comma seperated list of flight ids
     */

  }, {
    key: "getCachedFlightIds",
    value: function getCachedFlightIds() {
      if (this._flightIds !== undefined) {
        return this._flightIds;
      }

      if (this._flights === undefined) {
        this._flightIds = '';
      } else {
        var _context2;

        this._flightIds = (0, _from.default)((0, _values.default)(_context2 = this._flights).call(_context2)).join(',');
      }

      return this._flightIds;
    }
  }, {
    key: "setFlights",
    value: function setFlights(flights) {
      this._flights = flights;

      this._updateFlights();
    }
  }, {
    key: "getFlags",
    value: function getFlags() {
      var _this = this;

      if (this._flights) {
        return _promise.default.resolve();
      }

      if (this._pendingFlightRequest !== undefined) {
        return this._pendingFlightRequest;
      }

      if (this._endpoint === undefined) {
        throw new Error('Missing endpoint for treatment service');
      }

      var url = new _url.default(this._endpoint);
      url.searchParams.set('clientId', this.clientId);
      this._pendingFlightRequest = this._fetch(url.toString()).then(function (response) {
        return response.json();
      }).then(function (treatmentAssignment) {
        var _context3;

        var flights = treatmentAssignment.Flights;

        if (flights === undefined) {
          return new _set.default();
        }

        _this._flights = (0, _reduce.default)(_context3 = (0, _keys.default)(flights)).call(_context3, function (set, key) {
          return set.add(flights[key]);
        }, new _set.default());
        _this._pendingFlightRequest = undefined;
        return _this._flights;
      }).catch(function (reason) {
        _this._pendingFlightRequest = undefined;
        return _promise.default.reject(reason);
      }).then(function () {
        return undefined;
      });
      return this._pendingFlightRequest;
    }
  }, {
    key: "resetOverrides",
    value: function resetOverrides() {
      this._flights = undefined;

      try {
        if (this._storage !== undefined) {
          this._storage.removeItem(flightsKey);
        }
      } catch (err) {
        console.error(err);
      }
    }
  }, {
    key: "saveOverride",
    value: function saveOverride(flightName, enabled) {
      var flights = this._flights;

      if (flights === undefined) {
        this._flights = new _set.default();
        flights = this._flights;
      }

      if (enabled) {
        flights.add(flightName);
      } else {
        flights.delete(flightName);
      }

      this._updateFlights();
    }
  }, {
    key: "_updateFlights",
    value: function _updateFlights() {
      var flights = this._flights;

      if (flights !== undefined) {
        try {
          if (this._storage !== undefined) {
            this._storage.setItem(flightsKey, (0, _stringify.default)((0, _from.default)((0, _values.default)(flights).call(flights))));
          }
        } catch (err) {
          console.error(err);
        }
      }
    }
  }]);
  return TreatmentService;
}();

exports.TreatmentService = TreatmentService;
var treatmentService = new TreatmentService();
exports.treatmentService = treatmentService;